import ApplicationData from './applicationData'

export type NavTabOptions = 'NEW' | 'RENEWAL' | 'EXPIRING_POLICIES'

export type AppStatusFilterOptions = 'IN_PROGRESS' | 'COMPLETED' | 'SUBMITTED' | 'REJECTED' | 'EXPIRING_POLICIES'

export type ApplicationTypeFilterOptions = 'ALL' | 'LAWYER' | 'JUDGE'

export type ActionButtonTypes = 'SEND_REMINDER' | 'REJECT' | 'SUBMIT' | 'DOWNLOAD' | 'CONTACT' | 'DELETE' | 'IMPERSONATE'

export interface ApplicationListData {
  id: number;
  applicantId: number;
  applicantName: string;
  applicantType: string;
  applicantEmail: string;
  firmSize: number;
  dateStarted: string;
  dateCompleted: string;
  dateRejected: string;
  dateSubmitted: string;
  reminders: string;
  dateUpdated: string;
  percentageOfCompletion: number;
  firmName: string;
  firmId: string;
}

export interface RenewalsListData {
  id: number;
  userId: number;
  userName: string;
  userType: string;
  userEmail: string;
  firmSize: number;
  dateStarted: string;
  dateCompleted: string;
  dateRejected: string;
  dateSubmitted: string;
  reminders: string;
  dateUpdated: string;
  percentageOfCompletion: number;
  renewalReminder: Array<string>;
  policyNumber: string;
  policyExpiryDate: string;
  firmName: string;
  firmId: string;
}

export interface ExpiringPoliciesListData {
  policyKey: string;
  version: number;
  effectiveDate: string;
  expiryDate: string;
  firmId: number;
  firmName: string;
  applicationId: number;
  applicantName: string;
  applicantEmail: string;
  applicantType: string;
  applicantRemindedAt: string;
  renewalId: number;
  renewalApplicantName: string;
  renewalApplicantEmail: string;
  renewalApplicantType: string;
  renewalApplicantRemindedAt: string;
}

export interface DefaultSearchData {
  totalCount: number;
  totalPages: number;
  currentPage: number;
}

export interface ApplicationListResponseData extends DefaultSearchData {
  applications: Array<ApplicationListData>;
}

export interface RenewalsListResponseData extends DefaultSearchData {
  renewals: Array<RenewalsListData>
}

export interface ISIExistingContactData {
  name: string;
  contactKey: string;
  clientKey: string;
  barCardNumber: string | null ;
  searchMethod: string;
  email: string;
}

export const NoExistingContactSelection : ISIExistingContactData = {
  contactKey: 'NONE',
  name: '',
  clientKey: '',
  barCardNumber: '',
  searchMethod: '',
  email: ''
};
export const NewContactSelection : ISIExistingContactData = {
  contactKey: 'NEW',
  name: '',
  clientKey: '',
  barCardNumber: '',
  searchMethod: '',
  email: ''
};


export type FirmSearchOption = 
  'FIRM_NUMBER' |
  'FIRM_NAME' |
  'ADMIN_FIRST_NAME' |
  'ADMIN_LAST_NAME' |
  'EMAIL' |
  'POLICY_NUMBER' |
  'QUOTE_NUMBER'

export interface FirmSearchListData {
  firmId: number;
  adminFirstName: string;
  adminLastName: string;
  email: string;
  policyNumber: string;
  quoteNumber: string;
  isFirmAdministrator: boolean;
  firmNumber: string;
  name: string;
}

export interface FirmSearchData extends DefaultSearchData {
  firms: Array<FirmSearchListData>;
}

export interface FirmDetailsAddressResponse {
  streetNumber: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  postalCode: string;
  suiteNumber: string;
  state: string;
  stateCode: string;
}

export interface FirmDetailsAddressData {
  address: FirmDetailsAddressResponse;
  email: string;
  phone: string;
  fax: string;
}

export interface FirmDetailsContactData {
  firstName: string;
  lastName: string;
  emailAddress: string;
  isFirmAdministrator: boolean;
}

export interface FirmDetailsData {
  applicationId: number;
  applicationData: ApplicationData;
  primaryContact: FirmDetailsContactData;
  secondaryContact: FirmDetailsContactData;
  mailingAddress: FirmDetailsAddressData;
  billingAddress: FirmDetailsAddressData;
  dateCompleted: string;
  dateSubmitted: string;
  firmNumber: string;
  name: string;
  number: string;
}

export interface FirmDetailsInvoiceData {
  nextPaymentTotal: number;
  nextPaymentDueDate: string;
  lastPaymentTotal: number;
  lastPaymentDueDate: string;
  remainingBalance: number;
  totalContractAmount: number;
  totalPaid: number;
  currentPaymentTotal: number;
  currentPaymentDueDate: string;
  policyKey: string;
  policyType: string;
}

export interface FirmDetailsPolicyData {
  perClaimLimit: number;
  aggregateLimit: number;
  perClaimDeductible: number;
  aggregateDeductible: number;
  expenseAllowance: number;
  premium: number;
  policyEffectiveDate: string;
  policyExpiryDate: string;
  policyKey: string;
  policyType: string;
}

export interface FirmDetailedContactData {
  isPrimary?: boolean;
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  contactKey?: number;
  id?: number;
}

export interface FirmDetailsContactsDetailedData {
  firmId: number;
  contacts: Array<FirmDetailedContactData>;
}

export interface FirmDetailsQuoteLimit {
  perClaimDeductible: number;
  aggregateDeductible: number;
  perClaimLimit: number;
  aggregateLimit: number;
}
export interface FirmDetailsQuoteData {
  quoteKey: string;
  paymentsInFull: number;
  subSequentPayment: number;
  /*
  perClaimLimit: number;
  aggregateLimit: number;
  perClaimDeductible: number;
  aggregateDeductible: number;
  */
  limits: Array<FirmDetailsQuoteLimit>;
  quoteExpiryDate: string;
  policyFound: boolean;
  quoteType: string;
}

export interface FirmDetailsUpdateAddressInputs {
  firmId: number;
  addressType: number;
  streetNumber: string;
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
  suiteNumber: string;
}

export interface FirmDetailsUpdateContactsInputs {
  email: string;
  phoneNumber: string;
  fax: string;
}